<template>
  <div class=" p-2">
    <div class="col-sm-12 search-form-title">
      <font-awesome-icon icon="search" />
      {{ $t('common.search') }}
    </div>
    <form
      @submit.prevent="onSubmit"
      @reset="onReset"
    >
        <div class="row">
            <div class="col-sm-4">
            <span class="span-title">
              {{ $t('orders.create_time') }} - {{ $t('trip_list.road_sec_from') }}
            </span>
                <div class="mb-3">
                    <input
                        id="start"
                        v-model="fromDate"
                        type="date"
                        class="form-control form-control-sm"
                    />
                </div>
            </div>
            <div class="col-sm-4">
            <span class="span-title">
              {{ $t('orders.create_time') }} - {{ $t('trip_list.road_sec_to') }}
            </span>
                <div class="mb-3">
                    <input
                        id="end"
                        v-model="toDate"
                        type="date"
                        class="form-control form-control-sm"
                    />
                </div>
            </div>
        </div>
      <div class="row">
        <div class="col-sm-4">
            <span class="span-title">
              {{ $t('orders.status') }}
            </span>
            <div class="mb-3">
                <select
                    id="status"
                    v-model="status"
                    class="form-select form-select-sm"
                >
                    <option :value="-1">
                        {{ $t('orders.select_status') }}
                    </option>
                    <option :value="0">
                        {{ $t('inspection.options.open') }}
                    </option>
                    <option :value="2">
                        {{ $t('inspection.options.okay') }}
                    </option>
                    <option :value="3">
                        {{ $t('inspection.options.defects') }}
                    </option>
                    <option :value="4">
                        {{ $t('inspection.options.ban') }}
                    </option>
                </select>
            </div>
        </div>
        <div class="col-sm-4" style="padding-top: .4em">
            <open-contract-filter
                :to="toDate"
                :from="fromDate"
                :show-company="false"
                :show-only-my-contracts-option="true"
                @contract-selected="setContract"
            />
        </div>
      </div>
      <div class="col-sm-12 button-container">
        <button type="reset" class="btn btn-danger form-button">
          {{ $t('ins_report.clear') }}
        </button>
        <button type="submit" class="btn btn-primary form-button">
              {{ $t('ins_report.search') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {timeUtils} from '../../mixins/TimeUtils'
import OpenContractFilter from "@/components/contract/OpenContractFilter";

export default {
    name: 'WorkDefectSearch',
    components: {OpenContractFilter},
    mixins: [restApi, timeUtils],
    data: function () {
        return {
            status: 0,
            contract: null,
            fromDate: null,
            toDate: null,
        }
    },
    mounted: function () {
        if (!this.fromDate) {
            this.fromDate = this.timestampToDateInput(this.getMonthStart())
        }
    },

    methods: {
        setContract(item) {
            this.contract = item
        },


        onSubmit: function () {
            var params = {}
            if (this.status >= 0) {
                params.status = this.status
            }
            if (this.contract) {
                params.contract = this.contract.id
            }
            if (this.fromDate !== null && this.fromDate.trim()) {
                params.dateFrom = this.localTimeToUtcTime(this.fromDate).getTime()
            }
            if (this.toDate !== null && this.toDate.trim()) {
                params.dateTo = this.getEndOfTheDay(this.toDate).getTime()

            }
            this.$emit('search', params)
        },

        onReset: function () {
            this.status = 0
            this.contract = null
            this.fromDate = null
            this.toDate = null
        }
    }
}
</script>

<style scoped>

</style>
